<template>
    <div>
        <models-base-form
            :creating="creating"
            :newObject="newObject"
            :editObject="audiovisual"
            :service="service"
            @created="onCreated($event)"
            @updated="onUpdated($event)"
        >
            <template v-slot:form="{ object }">
                <v-select
                    v-model="object.tipoAudiovisualId"
                    @change="setSelectedTipoAudiovisual"
                    :items="tipoAudiovisuales"
                    item-text="tipoAudiovisual"
                    item-value="id"
                    label="Tipo Audiovisual"
                ></v-select>

                <template v-if="selectedTipoAudiovisual && selectedTipoAudiovisual.tipoAudiovisual == 'Malla'">
                    <v-file-input
                        label="PDF de la Malla (Tamaño máximo 2MB)"
                        @change="onFileChange($event, 'url', object)"
                    ></v-file-input>

                    <div class="text-center" v-if="uploadingMalla">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>

                    <div v-if="!uploadingMalla && object.url">
                        <a :href="object.url" target="_blank">{{ object.url }}</a>
                    </div>

                    <v-dialog v-model="mallaErrorDialog" width="500">
                        <v-card>
                            <v-card-title class="headline grey lighten-2">
                                Error al subir el archivo PDF
                            </v-card-title>
                            <v-card-text>
                                "No se ha podido subir la malla. Por favor inténtelo en unos momentos."
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="mallaErrorDialog = false">
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>

                <v-text-field v-else v-model="object.url" label="Url"></v-text-field>
            </template>
        </models-base-form>
    </div>
</template>

<script>
import { AudiovisualesService, TipoAudiovisualesService, UploadsService } from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            service: AudiovisualesService,
            newObject: {
                url: null,
                carreraSedeId: this.carreraSedeId
            },
            tipoAudiovisuales: null,
            selectedTipoAudiovisual: null,
            mallaErrorDialog: false,
            uploadingMalla: false
        }
    },
    props: ["creating", "audiovisual", "carreraSedeId"],
    methods: {
        onCreated(audiovisual) {
            this.$emit("created", audiovisual)
        },
        onUpdated(audiovisual) {
            this.$emit("updated", audiovisual)
        },
        setSelectedTipoAudiovisual(tipoAudiovisualId) {
            this.selectedTipoAudiovisual = this.tipoAudiovisuales.find(ta => ta.id == tipoAudiovisualId)
        },
        onFileChange: function(file, key, item) {
            if (!file) {
                item[key] = undefined

                return
            }

            this.uploadingMalla = true

            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.onload = () => {
                UploadsService.create({
                    file: reader.result.replace(/^data:.+;base64,/, ""),
                    name: file.name,
                    prefix: "carrera_sedes/mallas"
                }).then(res => {
                    if (res.success) {
                        item[key] = res.pathToFile
                    } else {
                        this.mallaErrorDialog = true
                    }

                    this.uploadingMalla = false
                })
            }
        }
    },
    created() {
        TipoAudiovisualesService.where().then(tas => (this.tipoAudiovisuales = tas))
    }
}
</script>
